import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

export const getVendorsByType = createAsyncThunk(
    "community/getVendorsByType",
    async ({ vendor_master_name, user_id, realtor_code }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("/community/realtor", {
                params: {
                    vendor_master_name,
                    user_id,
                    realtor_code
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const postVendorDetails = createAsyncThunk(
    "community/postVendorDetails",
    async (formdata, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "/community/vendor_details",
                formdata
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchVendorList = createAsyncThunk(
    "community/getvendorlist",
    async ({ all }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("/community/get-all-subvendors", {
                params: {
                    all
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchAllCities = createAsyncThunk(
    "fetchAllCities",
    async ({ page, page_size, search }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                "/community/get-cities", {
                params: {
                    page: page,
                    page_size: page_size,
                    search: search,
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const vendorSubscriptionApi = createAsyncThunk(
    "vendorsubscription/createvendorsubscription",
    async ({ user_id, city_id, product_id }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "payment/ad-banner-subscription/",
                {
                    user_id,
                    city_id,
                    product_id,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const vendorFetchSubscriptionApi = createAsyncThunk(
    "vendorsubscription/vendorFetchSubscriptionApi",
    async (userId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("/payment/ad-banner-subscription/",
                {
                    params: {
                        user_id: userId,
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const vendorCancelSubscriptionApi = createAsyncThunk(
    "cancelsubscription/vendorCancelSubscriptionApi",
    async ({ user_id, subscription_id, city_id, record_id }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "payment/vendor-subscription-cancel",
                {
                    user_id,
                    subscription_id,
                    city_id,
                    record_id
                }
            );
            return response.data;
        } catch (error) {
            if (error.response?.status === 404) {
                return []; // Return an empty array instead of rejecting
            }
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const uploadBannerImage = createAsyncThunk(
    "uploadBannerImage",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "/community/upload-ads-banner",
                formData
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchBannerImage = createAsyncThunk(
    "fetchBannerImage",
    async (userId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                "/community/upload-ads-banner",
                {
                    params: {
                        user_id: userId,
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const deleteBannerImage = createAsyncThunk(
    "fetchBannerImage",
    async (advertisement_library_id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(
                "/community/upload-ads-banner",
                {
                    params: {
                        advertisement_library_id: advertisement_library_id,
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const editBannerImage = createAsyncThunk(
    "uploadBannerImage",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(
                "/community/upload-ads-banner",
                formData
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const SubscriptionForVendorApi = createAsyncThunk(
    "vendorsubscriptions/createvendorsubscriptions",
    async ({ user_id, city_id, product_id }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "payment/vendor-create-subscription",
                {
                    user_id,
                    city_id,
                    product_id,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchSubscribedVendorApi = createAsyncThunk(
    "fetchVendorsubscribed/getVendorsubscribed",
    async (userId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("payment/vendor-create-subscription",
                {
                    params: {
                        user_id: userId,
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchBillingHistory = createAsyncThunk(
    "fetchBillingHistory",
    async (userId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`payment/subscription-plan-history/${userId}`,);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);